module.exports = __webpack_public_path__ + "img/card-brand-diners-club.dba7d9d2.png";